module.exports = __webpack_public_path__ + "static/media/vodka.c8f2e76d.jpg";